"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const content_1 = __importDefault(require("./content"));
require("@hotmart/cosmos/dist/collapse");
const Collapse = ({ children, className, onClick, active = false, arrow = 'right' }) => {
    return ((0, jsx_runtime_1.jsx)("hot-collapse", { class: (0, classnames_1.default)(className, {
            'hot-collapse--arrow-start': arrow === 'left'
        }), onClick: onClick, ...(active && { active }), children: children }));
};
Collapse.Content = content_1.default;
exports.default = Collapse;
